// extracted by mini-css-extract-plugin
module.exports = {"aSelect":"index_aSelect_2hINA"};